// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"c96fddf3","235":"bd086a6c","247":"9a4cc0dd","298":"15b932c0","381":"8054bf7b","823":"aad163f7"}[chunkId] + ".chunk.css";
};